import React from "react";
import DiaryBoard from "../../components/diary/DiaryBoard";
import { Navigate, Route, Routes } from "react-router-dom";
import StudentMainProfile from "../../components/sections/StudentMainProfile";
import DynamicProfile from "../instructor/pages/DynamicProfile";
import HelpPage from "../instructor/pages/HelpPage";
import Menu from "./StudentMenu";
import FriendsPage from "./pages/FriendsPage";
import Index from "./pages/Index";
import NotificationList from "./pages/NotificationList";
import Settings from "./pages/Settings";
// v1 submission-workflow screen, unrouted by the Assignment-V2 redesign
// import ManageAssignment from "./pages/assignment/ManageAssignment";
import AssignmentList from "./pages/assignment-v2/AssignmentList";
import SwitchAttendance from "./pages/attendance/SwitchAttendance";
import ViewLeaveDetails from "./pages/attendance/ViewLeaveDetails";
import CourseBoard from "./pages/courseboard";
// import AssignmentEvaluationView from "./pages/courseboard/AssignmentEvaluationView";
import ExamEvaluationView from "./pages/courseboard/ExamEvaluationView";
import StudentSwitchTab from "./pages/courseboard/studentSwitchTab";
import ManageExam from "./pages/exam/ManageExam";
import HomeWorkBroadcast from "./pages/message/HomeWorkBroadcast";
// import TemplateList from "./pages/reportcard/TemplateList";
// import ViewStudentTemplate from "./pages/reportcard/ViewStudentTemplate";
import Schedule from "./pages/schedule";
import StudentSwitchTransportation from "./pages/transportation/StudentSwitchTransportation";
import StudentLiveTracking from "./pages/Live tracking";

import TemplateList from "./pages/reportCard-v2/TemplateList";
import ViewStudentTemplate from "./pages/reportCard-v2/ViewStudentTemplate";

const url = "/dashboard";

const StudentRoutes = () => {
  return (
    <Routes>
      <Route path="student/menu" element={<Menu />} />
      <Route path="student/menu/profile" element={<StudentMainProfile />} />
      <Route path="student/menu/friends" element={<FriendsPage />} />
      <Route path="student/menu/friends/:userId" element={<DynamicProfile />} />
      <Route path="student/help" element={<HelpPage />} />
      <Route path="student/menu/notifications" element={<NotificationList />} />
      {/* <Route path="student/menu/assignment/:id" element={<AssignmentEvaluationView />} /> */}
      <Route path="student/menu/exam/:id" element={<ExamEvaluationView />} />
      <Route path="student/menu/setting/" element={<Settings />} />
      <Route path="student/menu/courses-board" element={<CourseBoard />} />
      <Route path="student/:className/:classId/:subjectId" element={<StudentSwitchTab />} />
      <Route path="student/menu/attendance" element={<SwitchAttendance />} />
      <Route path="student/menu/student/leave/:id" element={<ViewLeaveDetails />} />
      <Route path="student/menu/template/report-card/:id" element={<ViewStudentTemplate />} />
      <Route path="student/menu/report-card" element={<TemplateList />} />
      <Route path="student/menu/schedule/" element={<Schedule />} />
      <Route path="student/menu/homework/" element={<HomeWorkBroadcast />} />
      <Route path="student/menu/diary" element={<DiaryBoard role="student" mode="senior" />} />
      <Route path="student/menu/transportation/" element={<StudentSwitchTransportation />} />
      <Route path="student/menu/live-tracking/" element={<StudentLiveTracking />} />
      <Route path="student/menu/assignment" element={<AssignmentList />} />
      <Route path="student/menu/exam/" element={<ManageExam />} />
      <Route path="student/home" element={<Index />} />

      <Route index element={<Navigate to={`${url}/student/home`} replace />} />
    </Routes>
  );
};

export default StudentRoutes;
